<template>
  <div class="video-player-wrapper mt-1 mb-1">
    <video
      v-if="videoSource"
      autoplay
      controls
      muted
      preload="metadata"
      controlslist="nodownload"
      playsinline=""
      class="video-player"
    >
      <source type="video/mp4" :src="videoSource" />
    </video>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    videoSource: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
  },
  methods: {},
}
</script>

<style scoped lang="scss">
.video-player {
  // border-style: dashed;
  height: 225px;
  width: 210px;
}
</style>
